import { Flex, Image } from '@chakra-ui/react';
import S6Logo from '../../assets/S6_full_logo_dark.png';
import { HeaderMenu } from './HeaderMenu';
import { LoadingBar } from './LoadingBar';

interface MobileHeaderProps {
    color: string;
    isLoading: boolean;
}

export const MobileHeader: React.FC<MobileHeaderProps> = ({ color, isLoading }) => {
    return (
        <Flex className={'mobile-header'}>
            <Flex className={'mobile-header-content'}>
                <Image className={'s6-logo'} src={S6Logo} />
                <HeaderMenu />
            </Flex>
            <LoadingBar barColour={color} isLoading={isLoading} />
        </Flex>
    );
};
